module.exports = __webpack_public_path__ + "static/convenience-69cc6fdc885bcaf983d94b63a9cfa9c2.png";